import { useEffect, useMemo } from "react";
import { useHistory } from "react-router";
import useUser from "../../user/hooks/use-user";

export default function useGTag() {
    const history = useHistory();
    const { user, libraryCode } = useUser();

    const userParams = useMemo(() => {
        return {
            complete_task_count: user?.completedTasks.length,
            library_code: libraryCode
        }
    }, [user, libraryCode]);

    useEffect(() => {
        const unregister = history.listen((location) => {
            gtag('set', {
                page_path: location.pathname,
                page_location: window.location.href,
                ...userParams
            });
            gtag('event', 'page_view', {
                ...userParams
            });
        })

        return () => {
            unregister();
        }
    }, [history, userParams]);

}
